import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'orderTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedOrder: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedOrder: (state, action) => {
            state.selectedOrder = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedOrder
} = stateSlice.actions

export default stateSlice.reducer
